import '@console/internal/i18n.js';
import './style.scss';

export const FLAG_KUBEVIRT = 'KUBEVIRT';

const plugin = [];

export default plugin;
